<script>
/**
 * Login component
 */
export default {
  data() {
    return {
      email: "",
      password: "",
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  props: {
    submitUrl: {
      type: String,
      required: true,
    },
    authError: {
      type: String,
      required: false,
      default: () => null,
    },
  },
  mounted() {
    this.isAuthError = !!this.authError;
    // ユーザー初期化
    this.$store.commit("setMenuItems", []);
    this.$store.commit("setUserName", "");
    this.$store.commit("setRoles", "");
  },
};
</script>
<style>
.login-bg {
  position: fixed;
  inset: 0;
  background-image: url('/images/login-bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.8;
}
.login-overlay {
  position: fixed;
  inset: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}
.login-card-wrapper {
  width: 480px;
}
.login-overlay .card {
  background: rgba(255, 255, 255, 0.92);
}
</style>
<template>
  <div>
  <div class="login-bg"></div>
  <div class="login-overlay">
  <div class="login-card-wrapper">
      <div class="card overflow-hidden mt-5">
        <div class="card-body pt-0">
          <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{ authError }}</b-alert>
          <h3 class="ps-2 pt-2 mt-4">Tournament System</h3>
          <!-- <div class="ps-2 pt-2 mt-4">
            <div style="font-size: 1.3rem; font-weight: bold;">Tournament System</div>
          </div> -->
          <b-form class="p-2 mt-3" :action="submitUrl" method="POST">
            <slot />
            <b-form-group id="input-group-1" label="User ID" label-for="input-1" class="mb-3">
              <b-form-input id="input-1" name="email" v-model="email" type="text"
                placeholder="Enter email"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-2" label="Password" label-for="input-2" class="mb-3">
              <b-form-input id="input-2" v-model="password" name="password" type="password"
                placeholder="Enter password"></b-form-input>
            </b-form-group>
            <!-- <b-form-checkbox
              class="form-check"
              id="customControlInline"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            >
              Remember me
            </b-form-checkbox> -->
            <div class="mt-4 pt-3 d-grid">
              <b-button type="submit" variant="primary" class="btn-block">Log In</b-button>
            </div>
            <!-- <div class="mt-4 text-center">
              <h5 class="font-size-14 mb-3">Sign in with</h5>

              <ul class="list-inline">
                <li class="list-inline-item">
                  <a
                    href="javascript: void(0);"
                    class="social-list-item bg-primary text-white border-primary"
                  >
                    <i class="mdi mdi-facebook"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a
                    href="javascript: void(0);"
                    class="social-list-item bg-info text-white border-info"
                  >
                    <i class="mdi mdi-twitter"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a
                    href="javascript: void(0);"
                    class="social-list-item bg-danger text-white border-danger"
                  >
                    <i class="mdi mdi-google"></i>
                  </a>
                </li>
              </ul>
            </div> -->
            <!-- <div class="mt-4 text-center">
              <a href="/password/reset" class="text-muted">
                <i class="mdi mdi-lock mr-1"></i> Forgot your password?
              </a>
            </div> -->
          </b-form>
        </div>
        <!-- end card-body -->
      </div>
      <!-- end card -->

      <div class="mt-5 text-center">
        <!-- <p>
          Don't have an account ?
          <a href="/register" class="fw-medium text-primary">Signup now</a>
        </p> -->
        <p>© {{ new Date().getFullYear() }} Avalon Technologies, Inc.</p>
      </div>
    </div>
    <!-- end login-card-wrapper -->
  </div>
  <!-- end login-overlay -->
  </div>
  <!-- end root -->
</template>
